// extracted by mini-css-extract-plugin
export default {"poorContainer":"PoorResponse_poorContainer__2jgxw","wordCount":"PoorResponse_wordCount__4lZ9X"};